import CustomCover from './CustomCover.component';

export default CustomCover;
